import { apiFetch } from "./http";

export type ChallengeAchievement = {
  id: string;
  group: "记录里程" | "动物伙伴" | "外观收藏" | "城市足迹" | "稀有卡牌";
  icon: string;
  title: string;
  detail: string;
  value: number;
  goal: number;
  unlocked: boolean;
  unlockedAt: string | null;
};

export type ChallengeTask = {
  id: string;
  title: string;
  detail: string;
  value: number;
  goal: number;
  rewardExperience: number;
  completed: boolean;
  claimed: boolean;
  claimedAt: string | null;
};

export type ChallengeState = {
  week: { key: string; startsAt: string; endsAt: string };
  profile: { experience: number; level: number; levelProgress: number; nextLevelExperience: number };
  metrics: {
    cards: number;
    coatCount: number;
    speciesCount: number;
    catCount: number;
    dogCount: number;
    cityCount: number;
    districtCount: number;
    streetCount: number;
    rareCount: number;
    ssrCount: number;
  };
  tasks: ChallengeTask[];
  achievements: ChallengeAchievement[];
  claimedRewardExperience?: number;
};

export function fetchChallengeState(token: string) {
  return apiFetch<ChallengeState>("/api/v1/me/challenges", { headers: { Authorization: `Bearer ${token}` } });
}

export function claimChallengeReward(token: string, taskId: string) {
  return apiFetch<ChallengeState>(`/api/v1/me/challenges/${encodeURIComponent(taskId)}/claim`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
  });
}
